import React, { createContext, useContext, useState, useEffect } from 'react';
import { db } from '@/config/firebase';
import { doc, onSnapshot, setDoc } from 'firebase/firestore';

const SettingsContext = createContext();

export const useSettings = () => useContext(SettingsContext);

const defaultSettings = {
  siteName: 'Digital Screens',
  logo: null,
  primaryColor: '#000000ff',
  secondaryColor: '#ffffffff',
  accentColor: '#f59e0b',
  darkMode: true,
  fontFamily: 'Inter',
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(defaultSettings);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onSnapshot(doc(db, 'settings', 'global'), (doc) => {
      if (doc.exists()) {
        setSettings({ ...defaultSettings, ...doc.data() });
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const updateSettings = async (newSettings) => {
    await setDoc(doc(db, 'settings', 'global'), { ...settings, ...newSettings }, { merge: true });
  };

  return (
    <SettingsContext.Provider value={{ settings, updateSettings, loading }}>
      {children}
    </SettingsContext.Provider>
  );
};
